module.exports = __webpack_public_path__ + "static/media/paypal.9e01fd9a.png";